import { classnames } from '@tailwindcss-classnames';

// eslint-disable-next-line import/prefer-default-export
export const wrapper = classnames('overflow-x-auto');
